"use client";

import { Hotel, Shirt } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CodigoDeVestimentaYAlojamiento() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const hotels = [{
    name: "Hotel Eleganza",
    url: "https://www.hoteleleganza.com"
  }, {
    name: "Posada Romántica",
    url: "https://www.posadaromantica.com"
  }, {
    name: "Suite Imperio",
    url: "https://www.suiteimperio.com"
  }];
  return;
}